import { ParseService } from "./ParseService";

export const $parse = new ParseService();

// @ts-ignore
window.$parse = $parse;
